import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Breadcrumbs from './components/Breadcrumbs';
import Footer from './components/Footer';
import Home from './components/Home';
import Category from './components/Category';
import Product from './components/Product';
import Search from './components/Search';
import MyAccount from './components/MyAccount';
import StaticPage from './components/StaticPage';
import AccountProfile from './components/AccountProfile';
import AccountAddresses from './components/AccountAddresses';
import AccountOrders from './components/AccountOrders';
import AccountWishlist from './components/AccountWishlist';
import MiniCart from './components/MiniCart';
import LoginModal from './components/LoginModal';
import RegisterModal from './components/RegisterModal';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { BreadcrumbProvider } from './context/BreadcrumbContext';
import { WishlistProvider } from './context/WishlistContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          <BreadcrumbProvider>
            <div className="App">
              <Header />
              <Breadcrumbs />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/about" element={<StaticPage />} />
                  <Route path="/contact" element={<StaticPage />} />
                  <Route path="/customer/account" element={<AccountProfile />} />
                  <Route path="/sales/order/history" element={<AccountOrders />} />
                  <Route path="/wishlist" element={<AccountWishlist />} />
                  <Route path="/customer/address" element={<AccountAddresses />} />
                  <Route path="/privacy-policy" element={<StaticPage />} />
                  <Route path="/terms-of-service" element={<StaticPage />} />
                  <Route path="/shipping-delivery" element={<StaticPage />} />
                  <Route path="/returns-refunds" element={<StaticPage />} />
                  <Route path="/*" element={<Category />} />
                  {/* Legacy redirects */}
                  <Route path="/my-account" element={<MyAccount />} />
                </Routes>
              </main>
              <Footer />
              <MiniCart />
              <LoginModal />
              <RegisterModal />
            </div>
          </BreadcrumbProvider>
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;